import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UtilityService } from '../utility.service';
import { BaseFormService } from '../BaseFormService';
import { environment } from 'environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CashBondFormService extends BaseFormService {
	constructor(httpClient: HttpClient, utilityService: UtilityService) {
		super(`${environment.apiUrl}forms/clients/$$clientId$$/cash-bond-form`, httpClient, utilityService);
	}

	submitForApproval(clientId: string, id: any, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${this.getUrl(clientId)}/${id}/approval`, {
				userId,
			})
			.pipe();
	}

	getAllForms(clientId: string, request: any): Observable<any[]> {
		return this.httpClient.post<any[]>(`${this.getUrl(clientId)}/${request}/all`, {}).pipe();
	}

	checkDuplicateBond(clientId: string, val: string): Observable<string> {
		return this.httpClient.get<string>(`${this.getUrl(clientId)}/${val}/duplicate`).pipe();
	}

	// CashBondReceiptFormController exposes the singular "document" segment, not the
	// plural one BaseFormService assumes, so the shared method would 404 here.
	deleteDocument(clientId: string, formId: any, docId: any): Observable<any> {
		return this.httpClient.delete<any>(`${this.getUrl(clientId)}/${formId}/document/${docId}`);
	}
}
